<template>
  <div class="my-3 flex flex-col flex-wrap overflow-auto md:overflow-y-hidden">
    <div class="inline-block min-w-full py-2 align-middle sm:px-1">
      <div v-if="rows.length" class="overflow-hidden border">
        <table class="w-full divide-y divide-border text-left">
          <thead class="bg-muted">
            <tr>
              <th
                v-for="th in columns"
                :key="th"
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted-foreground"
              >
                {{ $t(th.label) }}
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-border bg-white">
            <tr v-for="row in rows" :key="row">
              <td class="whitespace-nowrap px-6 py-4">
                <div class="text-sm font-medium text-foreground">
                  {{ row.reward }}
                </div>
              </td>
              <td class="whitespace-nowrap px-6 py-4">
                <div class="text-sm text-muted-foreground">{{ row.rewardWon }}</div>
              </td>
              <td v-if="columns.rewardRetrieved" class="whitespace-nowrap px-6 py-4">
                <div class="text-sm text-muted-foreground">{{ row.rewardRetrieved }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-center text-foreground">
        {{ $t('pages.contests.contestDetailPage.tables.thead.noData') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Object,
      required: true
    },
    rows: {
      type: Object,
      required: true
    }
  }
}
</script>
